<template>
  <v-container fluid>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Access Groups</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Access Group</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table class="elevation-1" :items="items" :headers="headers">
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              @editItem="onEditItem(item)"
              @deleteItem="onDeleteItem(item)"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <access-group-dialog
      @close="showAccessGroupDialog = false"
      v-model="selectedAccessGroup"
      :show="showAccessGroupDialog"
      @save="onSaveAccessGroup"
    />
    <div v-if="debug">
      <code
        >domain:

        {{ ownerAccessSettings }}</code
      >
    </div>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import AccessGroupDialog from "./AccessGroupDialog.vue";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions.vue";
const OWNER_ACCESS_SETTINGS = gql`
  query ownerAccessSettings($domain: String) {
    owners(first: 1, filter: { domain_eq: $domain, for_access_groups: true }) {
      edges {
        node {
          accessSettings {
            groupName
            settingName
            settingValue
          }
        }
      }
    }
  }
`;
const CREATE_ACCESS_GROUP = gql`
  mutation createAccessGroup($input: AccessGroupInput!) {
    createAccessGroup(input: $input) {
      id
      name
      accessSettings {
        groupName
        settingName
        settingValue
      }
    }
  }
`;
const UPDATE_ACCESS_GROUP = gql`
  mutation updateAccessGroup($input: AccessGroupInput!) {
    updateAccessGroup(input: $input) {
      id
      name
      accessSettings {
        groupName
        settingName
        settingValue
      }
    }
  }
`;
const DELETE_ACCESS_GROUP = gql`
  mutation deleteAccessGroup($id: ID!) {
    deleteDeleteAccessGroup(id: $id) {
      name
    }
  }
`;
import { ALL_ACCESS_GROUPS } from "../../../../constants/graphql";
export default {
  components: { AccessGroupDialog, DefaultListActions },
  name: "owner-controls",

  data() {
    return {
      debug: false,
      selectedAccessGroup: { name: "New Group", accessSettings: [] },
      showAccessGroupDialog: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
    };
  },

  computed: {
    ownerAccessSettings() {
      return this.owners
        ? this.owners.edges[0].node.accessSettings.map(removeGQLTypename)
        : [];
    },
    items() {
      return this.accessGroups
        ? this.accessGroups.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      console.log("creating new Access Group");
      this.selectedAccessGroup = {
        name: "New Group",
        accessSettings: [...this.ownerAccessSettings],
      };
      this.showAccessGroupDialog = true;
    },
    onSaveAccessGroup(payload) {
      const mutation = payload.id ? UPDATE_ACCESS_GROUP : CREATE_ACCESS_GROUP;
      this.$apollo
        .mutate({
          mutation,
          variables: { input: payload },
          refetchQueries: [
            {
              query: ALL_ACCESS_GROUPS,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Access Group saved.",
          });
          this.showAccessGroupDialog = false;
        })
        .catch(this.errorHandler);
    },
    onEditItem(item) {
      this.selectedAccessGroup = { ...item };
      this.showAccessGroupDialog = true;
    },
    onDeleteItem(item) {
      this.$apollo
        .mutate({
          mutation: DELETE_ACCESS_GROUP,
          variables: { id: item.id },
          refetchQueries: [
            {
              query: ALL_ACCESS_GROUPS,
            },
          ],
        })
        .then(() =>
          this.$store.dispatch("showAppSnackbar", {
            msg: "Access Group removed.",
          })
        )
        .catch(this.errorHandler);
    },
    errorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
  },

  apollo: {
    owners: {
      query: OWNER_ACCESS_SETTINGS,
      variables() {
        return { domain: this.$store.getters.userConfig.domain };
      },
    },
    accessGroups: {
      query: ALL_ACCESS_GROUPS,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/OwnerControls.vue